import {CommonReducer, ReducerFromState} from "../../@types/reducers";
import {BookmakerObject} from "../../@types/response";

export const getComparisons = (state: ReducerFromState<CommonReducer>): BookmakerObject[] => state.common.comparisons;